/**
 * Dossier URLs Configuration
 *
 * Update these URLs after uploading PDFs to S3.
 *
 * S3 Upload Instructions:
 * 1. Create an S3 bucket (e.g., cesim-game-assets)
 * 2. Upload the PDFs from frontend/dossier/ folder
 * 3. Make the bucket/objects publicly accessible or use CloudFront
 * 4. Update the URLs below with your S3/CloudFront URLs
 *
 * File mapping:
 * - Biologist: Centauri Dossier Mag spread_v3 Biologist.pdf
 * - Diver: Centauri Dossier Mag spread_v3 Diver.pdf
 * - Fixer: Centauri Dossier Mag spread_v3 Fixer.pdf
 * - Historian: Centauri Dossier Mag spread_v3 Historian.pdf
 * - Hunter: Centauri Dossier Mag spread_v3 Hunter.pdf
 * - Handbook: Centauri Handbook Mag spread_v1.pdf
 */

// TODO: Replace with your actual S3/CloudFront URLs after upload
const S3_BASE_URL = 'https://cesim-game-assets.s3.us-west-2.amazonaws.com';

export const DOSSIER_URLS: Record<string, string> = {
  Biologist: `${S3_BASE_URL}/Centauri-Dossier-Biologist.pdf`,
  Diver: `${S3_BASE_URL}/Centauri-Dossier-Diver.pdf`,
  Fixer: `${S3_BASE_URL}/Centauri-Dossier-Fixer.pdf`,
  Historian: `${S3_BASE_URL}/Centauri-Dossier-Historian.pdf`,
  Hunter: `${S3_BASE_URL}/Centauri-Dossier-Hunter.pdf`,
};

export const HANDBOOK_URL = `${S3_BASE_URL}/Centauri-Handbook.pdf`;

/**
 * Get the dossier URL for a specific role
 */
export function getDossierUrl(role: string): string | null {
  return DOSSIER_URLS[role] || null;
}

/**
 * Get the handbook URL
 */
export function getHandbookUrl(): string {
  return HANDBOOK_URL;
}
